import Header from "commons/components/Header/Header";
import React, { Fragment, useEffect } from "react";
import "./HomePage.less";
import { useNavigate } from "react-router-dom";

export const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/cart-private");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <div className="container-fix bg-img">
        <div className="body-container">
          <Header />
        </div>
      </div>
    </Fragment>
  );
};
